var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,3A15,15,0,1,0,33,18,15.005,15.005,0,0,0,18,3Zm0,21.75A6.75,6.75,0,1,1,24.75,18,6.741,6.741,0,0,1,18,24.75Zm0-8.25A1.5,1.5,0,1,0,19.5,18,1.5,1.5,0,0,0,18,16.5Z",
    transform: "translate(-3 -3)",
    fill: "#f57224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlbum);
export default __webpack_public_path__ + "static/media/icon-album.c765f38d6c0742ced1f14bfb4ebeac6d.svg";
export { ForwardRef as ReactComponent };